import moment from 'moment-timezone';
import { getCopyrightString, getApplicationName, getAppVersion } from '@gral/config.js';
import { GridContainerFullHeight, Typography } from '@ts/storybook';
declare const WEBPACK_BUILD_DATE: string;

const AboutPage = () => {
  const version = getAppVersion();

  return (
    <GridContainerFullHeight verticalAlign="center" horizontalAlign="center">
      <Typography variant="h3" text={getApplicationName()} />
      <Typography variant="body1" text={['Version', ' ', version, ' ', `(${moment(WEBPACK_BUILD_DATE).format('LL')})`]} />
      <Typography variant="body1" text={getCopyrightString()} />
    </GridContainerFullHeight>
  );
};

export default AboutPage;
